/**
 * @file Automatically generated by barrelsby.
 */

export * from './admin-layout.component';
